/**
 * List Domains Handler
 * 
 * CQRS Query Handler that delegates to DomainQueryService.
 * Thin adapter layer for read operations.
 * 
 * FIXED: No more Inversify - direct constructor injection following party-manager pattern.
 */

import { IQueryHandler, IPaginatedResult } from '@swoft/core';
import { ListDomainsQuery, DomainDto } from '../queries/GetDomainQuery';
import { DomainCQRSQueryService } from '../services/DomainQueryService';

export class ListDomainsHandler implements IQueryHandler<ListDomainsQuery, IPaginatedResult<DomainDto>> {
  constructor(
    private readonly domainQueryService: DomainCQRSQueryService
  ) {}

  async handle(query: ListDomainsQuery): Promise<IPaginatedResult<DomainDto>> {
    return await this.domainQueryService.listDomains(query.params);
  }
}